import React from 'react'
import styled from 'styled-components'
// import AniLink from 'gatsby-plugin-transition-link/AniLink'
import SVG from 'react-inlinesvg'

import IconChevron from '../../assets/svg/chevron.svg'

const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 50px;
  margin: 30px 0;
  width: 100%;

  ${({ theme }) => theme.media.tablet} {
  }

  ${({ theme }) => theme.media.desktop} {
    margin: 20vh 0 10vh 50%;
    width: 50%;
  }
`

const Box = styled.a`
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: ${({ color }) => color};
  color: ${({ fontColor }) => fontColor};
  transition: all 0.3s ease;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;

  :before {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    content: '';
  }

  ${({ theme }) => theme.media.desktop} {
    aspect-ratio: 1.5 / 1;
  }
`

const Title = styled.h2`
  position: relative;
  height: 80px;
  overflow: hidden;

  h2 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;

    > span {
      position: relative;
      top: -10px;
      display: block;
      height: 60px;
      line-height: 70px;
      font-size: 22px;
      font-weight: ${({ theme }) => theme.font.bold};
      text-align: center;
    }
  }
`

const Awards = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transition: transform 0.3s ease;

  ${({ active, activeMob }) =>
    active
      ? 'transform: translate3d(0,0,0);'
      : 'transform: translate3d(101%,0,0);'}

  > a {
    display: block;
    transition: transform 0.3s 0.3s ease;
  }

  > a:last-child {
    ${({ activeMob }) =>
      activeMob
        ? 'transform: translate3d(0,0,0);transition: transform 0s ease;'
        : 'transform: translate3d(101%,0,0);'}
  }
`

const Slider = ({ projects, currentProjectIndex }) => (
  <Wrapper>
    {projects.map(project => (
      <Box
        href={`${project.slug}`}
        color={project.themeColor}
        fontColor={project.secondaryColor}
      >
        <Title active={currentProjectIndex}>
          <div>
            <h2>
              <span>{project.name}</span>
            </h2>
          </div>
        </Title>
        {/* </AniLink> */}
        <Awards active={project.award} activeMob={project.mobileAward}>
          <a
            href={project.award || ''}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="53.08" height="171.358">
              <path
                class="js-color-bg"
                fill="black"
                d="M0 0h53.08v171.358H0z"
              />
              <g class="js-color-text" fill="white">
                <path d="M20.047 153.665v-1.9h3.888v-4.093h-3.888v-1.9h10.231v1.9h-4.59v4.093h4.59v1.9zM29.898 142.236c-.331.565-.784.997-1.359 1.294s-1.222.446-1.944.446c-.721 0-1.369-.149-1.943-.446a3.316 3.316 0 0 1-1.36-1.294c-.331-.564-.497-1.232-.497-2.002s.166-1.438.497-2.002a3.316 3.316 0 0 1 1.36-1.294c.574-.297 1.223-.445 1.943-.445.723 0 1.369.148 1.944.445a3.307 3.307 0 0 1 1.359 1.294c.331.564.497 1.232.497 2.002s-.166 1.438-.497 2.002m-1.703-3.347c-.435-.33-.967-.496-1.601-.496-.633 0-1.166.166-1.601.496-.433.332-.649.78-.649 1.346 0 .564.217 1.013.649 1.345.435.331.968.497 1.601.497.634 0 1.166-.166 1.601-.497.435-.332.649-.78.649-1.345.001-.566-.214-1.014-.649-1.346M22.911 134.852v-1.813h1.186a3.335 3.335 0 0 1-.951-1.009 2.423 2.423 0 0 1-.352-1.271c0-.682.19-1.229.57-1.645.381-.413.932-.621 1.652-.621h5.262v1.812h-4.721c-.419 0-.727.096-.921.285-.195.19-.292.447-.292.769 0 .302.115.58.35.833.234.254.577.458 1.03.613.454.156.993.234 1.616.234h2.938v1.813h-7.367zM29.898 125.136a3.314 3.314 0 0 1-1.359 1.294c-.575.297-1.222.445-1.944.445-.721 0-1.369-.148-1.943-.445a3.322 3.322 0 0 1-1.36-1.294c-.331-.565-.497-1.232-.497-2.002 0-.771.166-1.438.497-2.003a3.313 3.313 0 0 1 1.36-1.293c.574-.297 1.223-.446 1.943-.446.723 0 1.369.149 1.944.446s1.028.728 1.359 1.293.497 1.232.497 2.003c.001.769-.166 1.436-.497 2.002m-1.703-3.347c-.435-.331-.967-.497-1.601-.497-.633 0-1.166.166-1.601.497-.433.331-.649.778-.649 1.345 0 .564.217 1.013.649 1.344.435.332.968.498 1.601.498.634 0 1.166-.166 1.601-.498.435-.331.649-.779.649-1.344.001-.567-.214-1.014-.649-1.345M22.911 117.75v-1.812h1.199c-.419-.265-.742-.586-.972-.966s-.345-.784-.345-1.213c0-.272.05-.569.146-.892l1.682.336a1.429 1.429 0 0 0-.205.76c0 .576.261 1.048.783 1.418.521.37 1.342.557 2.461.557h2.617v1.812h-7.366zM29.812 111.252c-.391.511-.857.851-1.403 1.016l-.776-1.446c.381-.138.68-.329.893-.577.215-.249.321-.544.321-.885a1.2 1.2 0 0 0-.168-.658c-.112-.175-.294-.263-.548-.263-.225 0-.406.105-.548.313-.142.21-.291.534-.446.973-.019.068-.058.17-.117.307-.224.565-.506 1.004-.848 1.315-.34.313-.779.467-1.314.467-.381 0-.727-.102-1.039-.306a2.185 2.185 0 0 1-.744-.84 2.554 2.554 0 0 1-.279-1.207c0-.497.105-.949.314-1.359.211-.408.506-.725.886-.949l.993 1.082c-.43.292-.644.686-.644 1.184a.84.84 0 0 0 .154.504.471.471 0 0 0 .401.212c.176 0 .338-.103.49-.307.15-.205.334-.604.547-1.199.205-.564.474-1.001.805-1.308.332-.308.756-.46 1.271-.46.721 0 1.299.229 1.732.687s.65 1.057.65 1.797c.001.759-.194 1.396-.583 1.907M35.481 17.006l-4.782 14.969h-3.266l-2.584-9.682-2.584 9.682h-3.268l-4.782-14.969h3.713l2.673 10.276 2.525-10.276h3.445l2.524 10.276 2.674-10.276zM37.978 27.163c1.426 0 2.496 1.068 2.496 2.495 0 1.425-1.07 2.495-2.496 2.495-1.425 0-2.494-1.07-2.494-2.495-.001-1.427 1.069-2.495 2.494-2.495" />
              </g>
            </svg>
          </a>
          <a
            href={project.mobileAward || ''}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="53.08" height="171.358">
              <path
                class="js-color-bg"
                fill="white"
                d="M0 0h53.08v171.358H0z"
              />
              <g class="js-color-text" fill="black">
                <path d="M20.047 153.665v-2.134l6.387-2.411-6.387-2.413v-2.133h10.23v1.9h-6.314l5.379 1.959v1.374l-5.379 1.958h6.314v1.9zM29.898 141.038a3.319 3.319 0 0 1-1.361 1.294c-.573.297-1.221.445-1.943.445-.721 0-1.368-.148-1.943-.445a3.326 3.326 0 0 1-1.359-1.294c-.331-.565-.497-1.232-.497-2.002 0-.771.166-1.438.497-2.003a3.317 3.317 0 0 1 1.359-1.293c.575-.298 1.223-.446 1.943-.446.723 0 1.37.148 1.943.446a3.31 3.31 0 0 1 1.361 1.293c.33.564.496 1.232.496 2.003.001.77-.165 1.437-.496 2.002m-1.703-3.348c-.435-.33-.968-.496-1.602-.496-.633 0-1.167.166-1.6.496-.435.331-.651.779-.651 1.346 0 .564.217 1.013.651 1.344.433.332.967.498 1.6.498.634 0 1.167-.166 1.602-.498.434-.331.649-.779.649-1.344.001-.566-.215-1.015-.649-1.346M30.117 131.176c-.186.326-.386.548-.6.665h.76v1.812H19.93v-1.812h3.654c-.215-.166-.4-.414-.556-.746a2.422 2.422 0 0 1-.235-1.038c0-1.082.345-1.912 1.031-2.492.688-.579 1.611-.869 2.771-.869s2.083.29 2.771.869c.687.58 1.029 1.41 1.029 2.492 0 .419-.093.792-.278 1.119m-1.871-2.099c-.399-.32-.949-.481-1.651-.481-.711 0-1.265.161-1.659.481-.395.322-.592.731-.592 1.229s.197.904.592 1.22c.395.317.948.476 1.659.476.712 0 1.264-.158 1.659-.476.394-.315.592-.723.592-1.22s-.2-.907-.6-1.229M21.625 124.98c-.225.225-.502.337-.833.337s-.608-.112-.833-.337-.337-.502-.337-.833c0-.332.112-.608.337-.833s.502-.337.833-.337.608.112.833.337.336.501.336.833c0 .332-.111.609-.336.833m1.286-1.739h7.367v1.812h-7.367v-1.812zM19.93 119.389h10.349v1.813H19.93zM29.832 116.189c-.375.531-.853.921-1.433 1.169a4.548 4.548 0 0 1-3.611 0 3.339 3.339 0 0 1-1.433-1.169c-.375-.532-.563-1.196-.563-1.995 0-.77.184-1.413.55-1.93a3.282 3.282 0 0 1 1.381-1.14 4.23 4.23 0 0 1 1.71-.365h.746v5.072a1.798 1.798 0 0 0 1.169-.49c.332-.307.497-.724.497-1.249 0-.41-.094-.753-.278-1.031-.185-.277-.473-.529-.862-.753l.541-1.462c.691.302 1.224.724 1.592 1.265.371.541.557 1.234.557 2.083 0 .799-.188 1.463-.563 1.995m-4.086-3.574c-.408.089-.746.262-1.008.52-.263.258-.395.611-.395 1.06 0 .429.136.784.408 1.067.273.282.604.458.994.526v-3.173zM20.047 102.852v-1.899l10.231-3.464v2.046l-2.412.746v3.244l2.412.745v2.046l-10.231-3.464zm6.065-2.031l-3.552 1.08 3.552 1.082v-2.162zM22.91 97.414v-1.827l5.059-1.316-5.059-1.243v-1.695l5.059-1.242-5.059-1.316v-1.827l7.367 2.354v1.607l-4.763 1.273 4.763 1.27v1.609zM29.811 85.676c-.391.419-.94.628-1.652.628-.73 0-1.314-.277-1.754-.833-.438-.555-.658-1.306-.658-2.251v-1.286h-.32c-.36 0-.632.122-.812.366-.181.243-.271.55-.271.92 0 .633.282 1.058.848 1.272l-.352 1.534a2.316 2.316 0 0 1-1.482-.942c-.375-.513-.563-1.132-.563-1.864 0-.984.261-1.747.782-2.287.521-.541 1.289-.812 2.302-.812h4.4v1.491l-.937.19c.702.575 1.053 1.33 1.053 2.265 0 .654-.195 1.19-.584 1.609m-1.383-3.245c-.276-.331-.645-.497-1.104-.497h-.144v1.213c0 .4.078.709.233.93.156.219.394.327.716.327a.658.658 0 0 0 .52-.226c.132-.151.197-.349.197-.593 0-.439-.14-.822-.418-1.154M22.91 78.179v-1.813h1.199a2.93 2.93 0 0 1-.972-.965 2.324 2.324 0 0 1-.345-1.213c0-.273.05-.57.146-.892l1.682.336a1.452 1.452 0 0 0-.205.76c0 .576.262 1.048.783 1.418s1.342.556 2.461.556h2.617v1.813H22.91zM29.364 71.716c-.687.561-1.61.84-2.771.84-1.158 0-2.082-.279-2.77-.84s-1.029-1.352-1.029-2.375c0-.42.074-.802.226-1.147.151-.347.339-.607.563-.782H19.93v-1.813h10.348v1.813h-.76c.224.117.427.35.607.693.18.348.27.759.27 1.236 0 1.023-.344 1.814-1.031 2.375m-1.11-3.99c-.396-.316-.947-.476-1.66-.476-.711 0-1.264.159-1.657.476a1.493 1.493 0 0 0-.593 1.221c0 .496.197.906.593 1.229.394.32.946.481 1.657.481.703 0 1.252-.161 1.652-.481.4-.322.6-.732.6-1.229 0-.498-.198-.905-.592-1.221M35.48 17.006l-4.783 14.969h-3.265l-2.584-9.682-2.584 9.682h-3.267l-4.782-14.969h3.712L20.6 27.282l2.525-10.276h3.445l2.525 10.276 2.673-10.276zM37.978 27.163c1.425 0 2.495 1.068 2.495 2.495 0 1.425-1.07 2.495-2.495 2.495-1.426 0-2.495-1.07-2.495-2.495-.001-1.427 1.069-2.495 2.495-2.495" />
              </g>
            </svg>
          </a>
        </Awards>
      </Box>
    ))}
  </Wrapper>
)

export default Slider
